import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import DashboardMetricValue from './DashboardMetricValue';
import { formatCurrency } from '../../utils/currencyUtils';
import { formatNumber } from '../../utils/dashboardMetricUtils';

const isMissing = (value) => value === null || value === undefined;

export const AppointmentsCountCard = ({ insights, isPending, hasError, onRetry }) => {
  const { t, i18n } = useTranslation();

  if (!isPending && !hasError && isMissing(insights?.appointmentsCount)) return null;

  return (
    <DashboardCard
      id="dashboard-appointments-count"
      title={t('dashboard.metrics.appointments')}
      subtitle={t('dashboard.metrics.appointmentsSubtitle')}
      isLoading={isPending}
      hasError={hasError}
      onRetry={onRetry}
    >
      <DashboardMetricValue emphasis value={formatNumber(insights?.appointmentsCount ?? 0, i18n.language, 0)} />
    </DashboardCard>
  );
};

export const RevenueCard = ({ insights, currencyCode, isPending, hasError, onRetry }) => {
  const { t } = useTranslation();

  if (!isPending && !hasError && isMissing(insights?.revenue)) return null;

  return (
    <DashboardCard
      id="dashboard-revenue"
      title={t('dashboard.metrics.revenue')}
      subtitle={t('dashboard.metrics.revenueSubtitle')}
      isLoading={isPending}
      hasError={hasError}
      onRetry={onRetry}
    >
      <DashboardMetricValue emphasis value={formatCurrency(insights?.revenue ?? 0, currencyCode)} />
    </DashboardCard>
  );
};
